module.exports = __webpack_public_path__ + "static/media/mackenzie_smith.9980b0b3.png";